import React from 'react';
export default function Loader() {
    return (React.createElement("div", { className: "loader" }));
}
